export default "__VITE_ASSET__cf05d3fe__"